"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMiscPageStoryData = exports.isStoryData = exports.isModuleDetailsStoryData = exports.isKitDetailsStoryData = exports.isActivityStoryData = exports.isGettingStartedStoryData = void 0;
/**
 * A base type guard to check if an object broadly conforms to the ISbStoryData structure.
 * This is useful for initial filtering of raw data from Storyblok to ensure it's a valid story object.
 *
 * @param story - the object to check
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isStoryData = (story) => {
    return (typeof story === 'object' &&
        story !== null &&
        'content' in story &&
        typeof story.content === 'object');
};
exports.isStoryData = isStoryData;
/**
 * Type guard to check if a Storyblok story is specifically a 'kit_details' component.
 *
 * @param story - the Storyblok story check
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isKitDetailsStoryData = (story) => {
    return isStoryData(story) && story.content.component === 'kit_details';
};
exports.isKitDetailsStoryData = isKitDetailsStoryData;
/**
 * Type guard to check if a Storyblok story is specifically a 'module_details' component.
 *
 * @param story - the Storyblok story check
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isModuleDetailsStoryData = (story) => {
    return isStoryData(story) && story.content.component === 'module_details';
};
exports.isModuleDetailsStoryData = isModuleDetailsStoryData;
/**
 * Type guard to check if a Storyblok story is specifically an 'activity' component.
 *
 * @param story - the Storyblok story check
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isActivityStoryData = (story) => {
    return isStoryData(story) && story.content.component === 'activity';
};
exports.isActivityStoryData = isActivityStoryData;
/**
 * Type guard to check if a Storyblok story is specifically a 'getting_started' component.
 *
 * @param story - the Storyblok story check
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isGettingStartedStoryData = (story) => {
    return isStoryData(story) && story.content.component === 'getting_started';
};
exports.isGettingStartedStoryData = isGettingStartedStoryData;
/**
 * Type guard to check if a Storyblok story is specifically a 'misc_page' component.
 *
 * @param story - the Storyblok story check
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isMiscPageStoryData = (story) => {
    return isStoryData(story) && story.content.component === 'misc_page';
};
exports.isMiscPageStoryData = isMiscPageStoryData;
